<div class="main-content">
	<div class="col-md-12">
		<div class="container-fluid tp-box" [@flipState]="flip">
			<div class="backside tp-box__side tp-box__back" [ngClass]="flip != 'inactive' ? '' : 'd-none'">
				<div class="cw-wrap od-flip-back" [ngStyle]="flipThemeVars">
					<div class="cw-icon-badge pointer" (click)="toggleFlip('na', '')" title="Back">
						<i class="material-icons">arrow_back</i>
					</div>
					<div class="cw-header">
						<div class="cw-title-group">
							<span class="cw-title">{{ fliptitle }}</span>
						</div>
					</div>
					<div class="cw-body" *ngIf="data">
						<app-open-orders (orderloaded)="selectItemLookup($event)" (preorderloaded)="selectItemLookup($event)" (orderinvoice)="invoiceOrder($event)" [flipfilter]="flipdata"></app-open-orders>
					</div>
				</div>
			</div>

			<div class="row tp-box__side tp-box__front orders-dashboard-row" id="frontside" *ngIf="picking">
				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Open Orders"
						icon="border_outer"
						accent="warning"
						[value]="picking.totalcount"
						[loading]="!pickingReady"
						[buckets]="openOrdersBuckets"
						[showView]="!!picking.totalcount"
						(view)="toggleFlip('openorders','')"
						(bucketView)="onStatBucket($event)">
					</app-dashboard-stat-card>
				</div>

				<div class="dashboard-stat-col"
					[ngClass]="{'col-lg-4 col-md-4 col-sm-6': viewing_title!='Open Quotes', 'col-lg-12 col-md-12 col-sm-12': viewing_title=='Open Quotes'}">
					<app-customer-open-quotes (viewData)="toggleFlipTest($event)"></app-customer-open-quotes>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Open RMA's"
						icon="menu_open"
						accent="danger"
						[value]="credits?.length"
						[loading]="pickLoading"
						[showView]="!pickLoading && credits?.length > 0"
						(view)="openCredits()">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Fillable"
						icon="done"
						accent="success"
						[value]="fillableCount"
						[loading]="!pickingReady || fillableCount === null"
						[buckets]="fillableBuckets"
						[showView]="!!picking.fillablecount"
						(view)="toggleFlip('fillable','')"
						(bucketView)="onStatBucket($event)">
					</app-dashboard-stat-card>
					<p class="od-extra-stat pointer" *ngIf="picking?.partialpickedcount" (click)="toggleFlip('partialpicked','')">
						({{ picking.partialpicked.length }}) Partial Picks
					</p>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Partially Fillable"
						icon="hail"
						accent="primary"
						[value]="partialFillableCount"
						[loading]="!pickingReady || partialFillableCount === null"
						[buckets]="partialFillableBuckets"
						[showView]="!!picking.paritalcount"
						(view)="toggleFlip('parital','')"
						(bucketView)="onStatBucket($event)">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Un-fillable Orders"
						icon="hourglass_disabled"
						accent="danger"
						[value]="notFillableCount"
						[loading]="!pickingReady"
						[buckets]="notFillableBuckets"
						[showView]="!!picking.notfillablecount"
						(view)="toggleFlip('notfillablecount','')"
						(bucketView)="onStatBucket($event)">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Overdue Orders"
						icon="taxi_alert"
						accent="primary"
						[value]="overdue_unique_length"
						[loading]="!overdues"
						[buckets]="overdueBuckets"
						[showView]="!!overdues?.length"
						(view)="toggleFlip('overdues','', true)"
						(bucketView)="onStatBucket($event)">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="In Picking"
						icon="inventory_2"
						accent="warning"
						[value]="picking.inpickcount"
						[loading]="!pickingReady"
						[showView]="!!picking.inpickcount"
						(view)="toggleFlip('inpick','')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Picked"
						icon="input"
						accent="success"
						[value]="picking.pickedcount"
						[loading]="!pickingReady"
						[showView]="!!picking.pickedcount"
						(view)="toggleFlip('picked','')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Loaded"
						icon="local_shipping"
						accent="info"
						[value]="picking.dispatchedcount"
						[loading]="!pickingReady"
						[showView]="!!picking.dispatchedcount"
						(view)="toggleFlip('dispatched','')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Dispatched"
						icon="local_shipping"
						accent="info"
						[value]="picking.dispatchedcount"
						[loading]="!pickingReady"
						[showView]="!!picking.dispatchedcount"
						(view)="toggleFlip('dispatched','')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Need Invoiced"
						icon="receipt"
						accent="info"
						[value]="picking.billablecount"
						[loading]="!pickingReady"
						[showView]="!!picking.billablecount"
						(view)="toggleFlip('billable','')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col">
					<app-dashboard-stat-card
						title="Refused Delivery"
						icon="remove"
						accent="danger"
						[value]="refused?.length"
						[loading]="!refused"
						[showView]="!!refused?.length"
						(view)="toggleFlip('refused','')">
					</app-dashboard-stat-card>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col" *ngIf="config?.env?.client === 'km'">
					<app-backorders-vs-stock></app-backorders-vs-stock>
				</div>

				<div class="col-lg-4 col-md-4 col-sm-6 dashboard-stat-col" *ngIf="config.features.adrs">
					<app-dashboard-stat-card
						title="ADRS Orders"
						icon="toys"
						accent="info"
						[value]="adrs?.adrscount"
						[loading]="!adrs"
						[showView]="!!adrs?.adrscount"
						(view)="toggleFlip('adrs','')">
					</app-dashboard-stat-card>
				</div>
			</div>

			<div class="row tp-box__side tp-box__front text-center" *ngIf="!picking">
				<svg class="spinner" width="35px" height="35px" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
					<circle class="path" fill="none" stroke-width="6" stroke-linecap="round" cx="33" cy="33" r="30"></circle>
				</svg>
			</div>
		</div>
	</div>
</div>
